// extracted by mini-css-extract-plugin
export var actionButton = "_m8-t";
export var buttonContainer = "_m8-0";
export var buttonContainer2 = "_m8-1";
export var buttonSection = "_m8-2";
export var details = "_m8-3";
export var dropdownItem = "_m8-5";
export var dropdownItemsContainer = "_m8-4";
export var fileInput = "_m8-r";
export var headerButton = "_m8-6";
export var icon = "_m8-7";
export var input = "_m8-8";
export var macroListItem = "_m8-9";
export var mainContent = "_m8-a";
export var microText = "_m8-b";
export var modal = "_m8-w";
export var optionsButton = "_m8-c";
export var paperclip = "_m8-s";
export var pillContent = "_m8-d";
export var preview = "_m8-e";
export var preview2 = "_m8-f";
export var quillEditor = "_m8-q";
export var selectedMacro = "_m8-g";
export var sidebar = "_m8-h";
export var sidebarHeader = "_m8-j";
export var sidebarList = "_m8-i";
export var sidebarListItem = "_m8-k";
export var sidebarSearch = "_m8-l";
export var snoozeDurationWrapper = "_m8-v";
export var statusPillContainer = "_m8-m";
export var tagsContainer = "_m8-n";
export var unselectedMacro = "_m8-o";
export var variable = "_m8-u";
export var wrapper = "_m8-p";